/* eslint-disable max-lines */
/* eslint-disable react/jsx-props-no-spreading */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const EllipsisGrid = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 111 120" fill="none" {...rest}>
      <mask
        id="mask0_890_177025"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-7"
        y="-14"
        width="134"
        height="135"
      >
        <ellipse
          opacity="0.1"
          cx="7.39892"
          cy="120.306"
          rx="0.33276"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="21.3618"
          cy="120.306"
          rx="0.332761"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="35.3152"
          cy="120.306"
          rx="0.332768"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="49.2703"
          cy="120.306"
          rx="0.332753"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="63.2251"
          cy="120.306"
          rx="0.332747"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="75.8501"
          cy="120.306"
          rx="0.332754"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="88.477"
          cy="120.306"
          rx="0.332758"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="101.107"
          cy="120.306"
          rx="0.332747"
          ry="0.334769"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="107.265"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="21.0296"
          cy="107.265"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="34.9817"
          cy="107.265"
          rx="0.66456"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="48.9368"
          cy="107.265"
          rx="0.66459"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="62.8909"
          cy="107.265"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="75.5201"
          cy="107.265"
          rx="0.664594"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="88.1438"
          cy="107.265"
          rx="0.66459"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="100.773"
          cy="107.265"
          rx="0.664575"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="94.5667"
          rx="0.664582"
          ry="0.668611"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="21.0297"
          cy="94.5655"
          rx="1.32979"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="34.9838"
          cy="94.5655"
          rx="1.32978"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="48.9389"
          cy="94.5655"
          rx="1.32978"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="62.9001"
          cy="94.5655"
          rx="1.3298"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="75.519"
          cy="94.5655"
          rx="1.32979"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="88.1489"
          cy="94.5655"
          rx="1.32979"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="100.774"
          cy="94.5655"
          rx="1.32979"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="81.8634"
          rx="0.664582"
          ry="0.668604"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="21.0297"
          cy="81.8632"
          rx="1.32979"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="34.9788"
          cy="81.8609"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="48.9398"
          cy="81.8609"
          rx="1.99375"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="62.8949"
          cy="81.8609"
          rx="1.99375"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="75.5189"
          cy="81.8608"
          rx="1.99373"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="88.1468"
          cy="81.8608"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="100.774"
          cy="81.8632"
          rx="1.32979"
          ry="1.33785"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="69.1562"
          rx="0.664582"
          ry="0.668604"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="21.0297"
          cy="69.1552"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="34.9788"
          cy="69.1566"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="48.9411"
          cy="69.1558"
          rx="2.65834"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="62.8954"
          cy="69.1558"
          rx="2.65834"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="75.5155"
          cy="69.1558"
          rx="2.65831"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="88.1468"
          cy="69.1566"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="100.774"
          cy="69.1551"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="56.452"
          rx="0.664582"
          ry="0.668604"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="21.0297"
          cy="56.4508"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="34.9788"
          cy="56.4543"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="48.9411"
          cy="56.4525"
          rx="2.65834"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.6"
          cx="62.8959"
          cy="56.4555"
          rx="3.32291"
          ry="3.34303"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="75.5155"
          cy="56.4525"
          rx="2.65831"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="88.1468"
          cy="56.4543"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="100.774"
          cy="56.4509"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="42.4128"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="21.0297"
          cy="42.4126"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="34.9788"
          cy="42.4112"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="48.9411"
          cy="42.4094"
          rx="2.65834"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="62.8954"
          cy="42.4094"
          rx="2.65834"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.5"
          cx="75.5155"
          cy="42.4094"
          rx="2.65831"
          ry="2.67443"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="88.1468"
          cy="42.4112"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="100.774"
          cy="42.4126"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="28.3697"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="21.0297"
          cy="28.3686"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="34.9788"
          cy="28.372"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="48.9398"
          cy="28.372"
          rx="1.99375"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="62.8949"
          cy="28.372"
          rx="1.99375"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="75.5189"
          cy="28.372"
          rx="1.99373"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="88.1468"
          cy="28.372"
          rx="1.99374"
          ry="2.00582"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="100.774"
          cy="28.3687"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="7.06473"
          cy="14.3305"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.3"
          cx="21.0297"
          cy="14.3303"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="34.9838"
          cy="14.3303"
          rx="1.32978"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="48.9389"
          cy="14.3303"
          rx="1.32978"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="62.9001"
          cy="14.3302"
          rx="1.3298"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="75.519"
          cy="14.3303"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="88.1489"
          cy="14.3303"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.2"
          cx="100.774"
          cy="14.3303"
          rx="1.32979"
          ry="1.33784"
          fill="#E9B6D2"
        />
        <ellipse
          cx="7.06473"
          cy="0.287474"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="21.0296"
          cy="0.287505"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="34.9817"
          cy="0.287505"
          rx="0.66456"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="48.9368"
          cy="0.287474"
          rx="0.66459"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="62.8909"
          cy="0.287474"
          rx="0.664582"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="75.5201"
          cy="0.287474"
          rx="0.664594"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="88.1438"
          cy="0.287505"
          rx="0.66459"
          ry="0.668608"
          fill="#E9B6D2"
        />
        <ellipse
          opacity="0.1"
          cx="100.773"
          cy="0.287474"
          rx="0.664575"
          ry="0.668608"
          fill="#E9B6D2"
        />
      </mask>
      <g mask="url(#mask0_890_177025)">
        <ellipse
          cx="60.1753"
          cy="51.7736"
          rx="59.5848"
          ry="59.9455"
          fill={color}
        />
      </g>
    </StyledIcon>
  );
};

EllipsisGrid.propTypes = {
  color: PropTypes.string
};

EllipsisGrid.defaultProps = {
  color: '#CACACA'
};

export default EllipsisGrid;
